<style>
    .my-drop-zone { border: dashed 1px #9AA3A8; padding: 25px; margin-top: 10px; background-color: white; text-align: center;}
    .nv-file-over { border: dashed 1px #00355E; background-color: lightgray; } /* Default class applied to drop zones on over */
    .another-file-over-class { border: dotted 3px green; }
    html, body { height: 100%; }
</style>
  <modal-component #sizeError
                   (accept)="modalContinueClick($event)"
                   [title]="getModalTitle()"
                   [data]="{
                    resizeOrClose:'close'}">
      <p>Complete actions on the files uploaded successfully.</p>
      <p>Close your browser/log out.</p>
      <p><strong>To continue uploading files, open a new browser session/log in.</strong></p>
      <p>Maximum allowed = 25 files</p>
      <p>Maximum total of files = 100MB</p>
      <p>Maximum HML (single) file size = 100MB</p>
      <p>Maximum CSV (single) file size = 1MB</p>
  </modal-component>
  <modal-component #typeError
                   (accept)="modalContinueClick($event)"
                   [title]="getModalTitle()"
                   [data]="{
                    resizeOrClose:'close'}">
                    <p>Some or all of the files you attempted to upload failed.</p>
  </modal-component>
  <div>
    <div ng2FileDrop
            [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
            (fileOver)="fileOverBase($event)"
            [uploader]="uploader"
            class="well my-drop-zone">
        <label for="files" class="custom-file-upload">Upload File</label>
        <input id="files" type="file" ng2FileSelect [uploader]="uploader" multiple (change)="onChange($event);"  />
        <label style="font-weight:normal">&nbsp; or Drag & Drop Files here </label>
        <span id="filcnt" style="font-size: 12px;">&nbsp; ({{getFileCnt()}} files uploaded of 25 maximum per session)</span>
    </div>
    <div class="intake-progress">
        <div>
        <label for="upler">Intake progress:</label>
          <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar" [ngStyle]="{ 'width': uploader.progress + '%' }">{{uploader.progress}}%</div>
          </div>
          <br><br>
        </div>
    </div>
</div>
